import * as React from 'react';
import { CalendarViewType } from '../schema';

export function usePeekCalloutState(viewType: CalendarViewType, onCalloutDismiss?: () => void) {
    const [peekTarget, setPeekTarget] = React.useState<HTMLElement | undefined>(undefined);
    const [selectedItemId, setSelectedItemId] = React.useState<string | undefined>(undefined);
    const onClickCalendarEvent = React.useCallback((id: string, target?: HTMLElement) => {
        setPeekTarget(target);
        setSelectedItemId(id);
    }, []);

    const onEventsPeekCalloutDismissed = React.useCallback(
        // This logic is needed to allow quick event switching, if we set the
        // selectedItemId on dismiss it does not allow the next item to open.
        // We also need to verify that the specific event did not come from
        // an event on the calendar, if so we do not set the selectedItemId to undefined
        // we simply allow the click action to reset the selectedItemId to the next event.
        (ev?: any) => {
            const calledFromSurfaceItem =
                ev?.srcElement?.className?.search('CalendarSurfaceItem') > 0;
            if (
                (!calledFromSurfaceItem && viewType === CalendarViewType.Agenda) ||
                viewType === CalendarViewType.Month
            ) {
                setSelectedItemId(undefined);
            }
            setPeekTarget(undefined);
            onCalloutDismiss?.();
        },
        [onCalloutDismiss, viewType]
    );

    return {
        selectedItemId,
        peekTarget,
        setPeekTarget,
        onClickCalendarEvent,
        onEventsPeekCalloutDismissed,
    };
}
